export const BXUserCustomPropertiesCollection: string = 'BXUserCustomProperties';
export const NotificationSettingItemClass: string = 'PushNotificationSetting';
export const BXCustomPropertiesDataKey: string = 'data';
export const NotificationEnabledKey: string = 'isNotificationEnabled';
